import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, NavLink } from 'react-router-dom';
import { useApi } from 'model/Api';
import { Partner } from 'model/Partner';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import FormContent from 'component/part/FormContent';
import ConfirmResultModal from 'component/part/ConfirmResultModal';
import H2 from 'component/part/H2';

const PartnerShow: React.FC = () => {
  const api = useApi();
  const navigate = useNavigate();
  const urlParams = useParams<{ id: string }>();
  const partnerId = parseInt(urlParams.id || '');
  const [partner, setPartner] = useState<Partner>();
  const [confirm, setConfirm] = useState(false);

  const onSubmit = async () => {
    if (!partner) return false;
    const result = await api.partner.delete(partner.id);

    return result.ok && !!result.data?.result;
  };

  useEffect(() => {
    (async () => {
      if (partnerId) {
        const partnerResponse = await api.partner.get(partnerId);
        if (partnerResponse) {
          setPartner(partnerResponse);
        }
      }
    })();
  }, [partnerId]);

  return <Layout>
    <BackLink link='/partner/list' label='協力業者一覧'></BackLink>
    <H2>業者情報</H2>
    <div css={generalStyle.form}>
      <FormContent label='業者名'>
        <div css={generalStyle.item()}>{partner?.name || ''}</div>
      </FormContent>
      <FormContent label='日給'>
        <div css={generalStyle.item()}>{partner?.unitSalary ? `\xA5${partner.unitSalary.toLocaleString()}` : 'ー'}</div>
      </FormContent>
      {partner && (
        <div css={generalStyle.formRow}>
          <NavLink to={`/partner/${partner.id}/edit`} css={generalStyle.button()}>編集</NavLink>
          <button onClick={() => setConfirm(true)} css={generalStyle.button('warning')}>削除</button>
        </div>
      )}
    </div>
    <ConfirmResultModal
      display={confirm}
      onHide={() => setConfirm(false)}
      onSubmit={onSubmit}
      onOk={() => navigate('/partner/list')}
      objectType='partner'
      operationType='delete'
    />
  </Layout>;
};

export default PartnerShow;
